const normalizeStageId = value => {
    if (value === null || value === undefined) {
        return null;
    }

    const stageId = String(value).trim();
    return stageId || null;
};

const getOrderedStages = funnel =>
    Object.entries(funnel?.stages || {}).map(([id, stage], index) => ({
        id: String(id),
        name: stage?.name || String(id),
        index,
    }));

export const getChecklistAvailableStageId = checklistItem =>
    normalizeStageId(checklistItem?.available_stage_id);

export const getChecklistStageOptions = funnel =>
    getOrderedStages(funnel).map(stage => ({
        value: stage.id,
        label: stage.name,
    }));

export const getChecklistAvailableStageLabel = (checklistItem, funnel) => {
    const requiredStageId = getChecklistAvailableStageId(checklistItem);
    if (!requiredStageId) {
        return null;
    }

    return (
        getOrderedStages(funnel).find(stage => stage.id === requiredStageId)
            ?.name || requiredStageId
    );
};

export const getChecklistSourceInfo = (checklistItem, funnel) => {
    const sourceType = checklistItem?.source_type || (checklistItem?.source_stage_id ? 'stage_template' : 'manual');
    const sourceStageId = normalizeStageId(checklistItem?.source_stage_id);
    const sourceStageLabel = sourceStageId
        ? getOrderedStages(funnel).find(stage => stage.id === sourceStageId)?.name || sourceStageId
        : null;

    return {
        type: sourceType,
        stageId: sourceStageId,
        stageLabel: sourceStageLabel,
    };
};

export const getChecklistCompletionAvailability = (checklistItem, item) => {
    const requiredStageId = getChecklistAvailableStageId(checklistItem);
    const requiredStageLabel = getChecklistAvailableStageLabel(
        checklistItem,
        item?.funnel
    );

    if (!requiredStageId) {
        return {
            available: true,
            requiredStageId: null,
            requiredStageLabel: null,
        };
    }

    const currentStageId = normalizeStageId(item?.funnel_stage);
    const stages = getOrderedStages(item?.funnel);
    const requiredStage = stages.find(stage => stage.id === requiredStageId);
    const currentStage = stages.find(stage => stage.id === currentStageId);

    if (!requiredStage || !currentStage) {
        return {
            available: true,
            requiredStageId,
            requiredStageLabel,
        };
    }

    return {
        available: currentStage.index === requiredStage.index,
        requiredStageId,
        requiredStageLabel,
    };
};

export const isChecklistCompletionBlocked = (checklistItem, item) =>
    !checklistItem?.completed &&
    !getChecklistCompletionAvailability(checklistItem, item).available;
